import React from "react";
import styled from "styled-components";

import BasicHeaderSection from "../../sections/BasicHeaderSection";
import PrivacySection from "../../sections/PrivacySection";
import TitleSectionFederal from "../../V2-federal/sections/TitleSection";
import PrivacySectionFederal from "../../V2-federal/sections/PrivacySection";
import TitleSectionReflection1 from "../../V2-reflection-1/sections/TitleSection";
import PrivacySectionReflection1 from "../../V2-reflection-1/sections/PrivacySection";
import TitleSectionReflection2 from "../../V2-reflection-2/sections/TitleSection";
import PrivacySectionReflection2 from "../../V2-reflection-2/sections/PrivacySection";
import TitleSectionReflection3 from "../../V2-reflection-3/sections/TitleSection";
import PrivacySectionReflection3 from "../../V2-reflection-3/sections/PrivacySection";
import TitleSectionReflection4 from "../../V2-reflection-4/sections/TitleSection";
import PrivacySectionReflection4 from "../../V2-reflection-4/sections/PrivacySection";

const StyledPrivacyPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: calc(100vh - 100px);

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: calc(100vh - 80px);
  }
`;
const StyledPrivacyPage3 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  min-height: calc(100vh - 100px);

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: calc(100vh - 80px);
  }
`;
function PrivacyPage() {
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
    return (
      <StyledPrivacyPage>
        <TitleSectionFederal
          title="Privacy Notice And Cookies Policy"
        />
        <PrivacySectionFederal />
      </StyledPrivacyPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
    return (
      <StyledPrivacyPage>
        <TitleSectionReflection1
          title="Privacy Notice And Cookies Policy"
        />
        <PrivacySectionReflection1 />
      </StyledPrivacyPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
    return (
      <StyledPrivacyPage>
        <TitleSectionReflection2
          title="Privacy Notice And Cookies Policy"
        />
        <PrivacySectionReflection2 />
      </StyledPrivacyPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
    return (
      <StyledPrivacyPage3>
        <TitleSectionReflection3
          title="Privacy Notice And Cookies Policy"
        />
        <PrivacySectionReflection3 />
      </StyledPrivacyPage3>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
    return (
      <StyledPrivacyPage>
        <TitleSectionReflection4
          title="Privacy Notice And Cookies Policy"
        />
        <PrivacySectionReflection4 />
      </StyledPrivacyPage>
    );
  }
  return (
    <StyledPrivacyPage>
      <BasicHeaderSection
        title="Privacy Notice And Cookies Policy"
      />
      <PrivacySection />
    </StyledPrivacyPage>
  );
}

export default PrivacyPage;
